/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022-2023 (original work) Open Assessment Technologies SA
 */

import env from './env.js';
import { config as loginConfig } from '@/modules/login/config';
import { config as groupsConfig } from '@/modules/groups/config';
import { config as batteriesConfig } from '@/modules/batteries/config';
import { config as studentSessionsConfig } from '@/modules/studentSessions/config';
import { config as personalSpaceConfig } from '@/modules/personalSpace/config';
import { config as usersConfig } from '@/modules/users/config';
import { config as sessionsConfig } from '@/modules/sessions/config';
import { config as organizationConfig } from '@/modules/organization/config';
import { config as reportsConfig } from '@/modules/reports/config';
import { config as importConfig } from '@/modules/import/config';
import { config as dashboardsConfig } from '@/modules/dashboards/config';
import { config as explorerConfig } from '@/modules/explorer/config';
import { config as deliveriesConfig } from '@/modules/deliveries/config';
import { config as assetsConfig } from '@/modules/assets/config';
import { config as campaignsConfig } from '@/modules/campaigns/config';
import { config as testsConfig } from '@/modules/tests/config';
import emailVerificationConfig from '@/modules/emailVerifications/config';
import emailSubscriptionsConfig from '@/modules/emailSubscriptions/config.js';
import { config as publicSessionsConfig } from '@/modules/publicSessions/config';
import { config as systemSettingsConfig } from '@/modules/systemSettings/config.js';
import { config as sessionTemplatesConfig } from '@/modules/sessionTemplates/config';
import { config as supportConfig } from '@/modules/support/config';
import certificationSessionsConfig from '@/modules/certificationSessions/config.js';
import { config as aiLabsConfig } from '@/modules/aiLabs/config.js';
import { config as candidatesConfig } from '@/modules/candidates/config.js';
import { config as scoringProjectsConfig } from '@/modules/scoringProjects/config.js';

const handler = {
    get(target, prop) {
        if (prop in target) {
            const value = target[prop];
            const prefix = env('PATH_PREFIX') === 'undefined' ? '' : env('PATH_PREFIX');
            return typeof value === 'string' ? `${prefix}${value}` : new Proxy(value, handler);
        }
    }
};

export default new Proxy(
    {
        home: env('PATH_PREFIX') && env('PATH_PREFIX') !== '' ? '' : '/',
        login: loginConfig,
        contentBank: '/content-bank',
        groups: groupsConfig,
        batteries: batteriesConfig,
        diagnostic: '/diagnostic',
        users: usersConfig,
        studentSessions: studentSessionsConfig,
        personalSpace: personalSpaceConfig,
        sessions: sessionsConfig,
        organization: organizationConfig,
        deliveries: deliveriesConfig,
        reports: reportsConfig,
        import: importConfig,
        dashboards: dashboardsConfig,
        error: '/error',
        explorer: explorerConfig,
        assets: assetsConfig,
        campaigns: campaignsConfig,
        tests: testsConfig,
        publicSessions: publicSessionsConfig,
        emailVerifications: emailVerificationConfig,
        emailSubscriptions: emailSubscriptionsConfig,
        systemSettings: systemSettingsConfig,
        sessionTemplates: sessionTemplatesConfig,
        support: supportConfig,
        certificationSessions: certificationSessionsConfig,
        aiLabs: aiLabsConfig,
        candidates: candidatesConfig,
        scoringProjects: scoringProjectsConfig
    },
    handler
);
